import { render, staticRenderFns } from "./GenTablesCustom.vue?vue&type=template&id=42934bf2&scoped=true&"
import script from "./GenTablesCustom.vue?vue&type=script&lang=js&"
export * from "./GenTablesCustom.vue?vue&type=script&lang=js&"
import style0 from "./GenTablesCustom.vue?vue&type=style&index=0&id=42934bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42934bf2",
  null
  
)

export default component.exports